import React, { FC, memo } from 'react'
import cn from 'classnames'
import { includes } from 'lodash/fp'
import { IDetailsOrder } from '../../../types/orders'
import CrossIcon from '../../../icons/cross.svg'
import Tooltip from '../../../components/Tooltip'
import { format } from 'date-fns'
import ShippingInfo from '../SubmittedOrdersRow/shippingInfo'

interface IOrderHeaderProps {
  order: IDetailsOrder
  onNumberEdit: () => void
  onClose: () => void
  gmFlow?: boolean
  erpOrders?: string
}

const OrderHeader: FC<IOrderHeaderProps> = ({
  order,
  onNumberEdit,
  onClose,
  gmFlow,
  erpOrders: erpOrdersProp,
}) => {
  const submitted = includes(order.status, ['submitted', 'skipped'])
  const erpOrders = erpOrdersProp || order.account?.erpOrders

  return (
    <div className="order-modal_head">
      <div className="order-modal_head-number_branch form">
        {order.branch.name}
      </div>

      <div className="order-modal_head-number form">
        <div className="order-modal_title">Order&nbsp;</div>
        {submitted ? (
          <div
            className={cn('order-modal_number', { '-disabled': submitted })}
            onClick={onNumberEdit}
          >
            <span style={{ color: '#E4922F' }}>{order.navOrderId}</span>
            {order.navOrderId && order.purchaseOrderNumber && (
              <>&nbsp;/&nbsp;</>
            )}
            {order.purchaseOrderNumber}
          </div>
        ) : (
          <>
            -&nbsp;
            <div
              className={cn('order-modal_number', { '-disabled': submitted })}
              onClick={onNumberEdit}
            >
              {order.purchaseOrderNumber || 'Add PO Number'}
            </div>
          </>
        )}
        <button
          type="button"
          className="order-modal_back clear-button"
          onClick={onClose}
        >
          <CrossIcon width={15} height={16} />
        </button>
      </div>

      <div className="order-modal_status">
        <div className="order-modal_status-container form">
          <div
            className="order-modal_status-steps"
            style={{ textTransform: 'none', fontSize: '14px', fontWeight: 400 }}
          >
            {erpOrders === 'ipo' && !order.navOrderId ? (
              <span>Please check Ariba for tracking on this order</span>
            ) : (
              <ShippingInfo
                order={order}
                title="Estimated shipment on"
                fullDate={true}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(OrderHeader)
